<template>
  <div id="HomePage">
    <div class="banner-section1">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7">
            <div
              class="banner-content wow fadeInLeft"
              data-wow-duration="1.5s"
              data-wow-delay="0.2s"
            >
              <h1>海南华德科技有限公司</h1>
              <p>
                总部位于海口，注册资金 1000 万元，拥有 50+ 项软件著作权，是国家级高新技术企业、国家科技型中小企业、海南省高新技术种子企业与海南省创新型中小企业。我们专注医疗健康、电子政务、数字企业三大领域，致力成为国内一流的软件服务商。
              </p>
              <div class="button-group gap-5">
                <router-link to="/companyintroduction" class="eg-btn btn--primary btn--lg"
                  >了解华德科技</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-lg-5 position-relative">
            <div
              class="solar-vector-area wow fadeInRight"
              data-wow-duration="1.5s"
              data-wow-delay="0.2s"
            >
              <img
                src="@/assets/images/bg/banner1-vector.svg"
                class="img-fluid banner1-v1"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BannerSection",
};
</script>



// WEBPACK FOOTER //
// src/view/components/BannerSection.vue